// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ArbitrationDTO } from '../models';
import { UpdateArbitrationDTO } from '../models';
/**
 * ArbitrationsApi - axios parameter creator
 * @export
 */
export const ArbitrationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an Arbitration on a Claim, optionally attaching the summary document and publishing it
         * @param {string} claimId 
         * @param {number} [arbitratedAmount] 
         * @param {any} [file] Arbitration summary document
         * @param {boolean} [publish] Publish the arbitration in the same request. Requires a summary document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArbitration(claimId: string, arbitratedAmount?: number, file?: any, publish?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling createArbitration.');
            }
            const localVarPath = `/v2/arbitrations`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (claimId !== undefined) { 
                localVarFormParams.append('claimId', claimId as any);
            }
    
            if (arbitratedAmount !== undefined) { 
                localVarFormParams.append('arbitratedAmount', arbitratedAmount as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (publish !== undefined) { 
                localVarFormParams.append('publish', publish as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an Arbitration by Id
         * @param {string} id Arbitration id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArbitrationById(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getArbitrationById.');
            }
            const localVarPath = `/v2/arbitrations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish an Arbitration on a Claim
         * @param {string} arbitrationId Arbitration id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishArbitration(arbitrationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'arbitrationId' is not null or undefined
            if (arbitrationId === null || arbitrationId === undefined) {
                throw new RequiredError('arbitrationId','Required parameter arbitrationId was null or undefined when calling publishArbitration.');
            }
            const localVarPath = `/v2/arbitrations/{arbitrationId}/publish`
                .replace(`{${"arbitrationId"}}`, encodeURIComponent(String(arbitrationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Arbitration on a Claim
         * @param {string} arbitrationId Arbitration id
         * @param {UpdateArbitrationDTO} updateArbitrationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArbitration(arbitrationId: string, updateArbitrationDTO: UpdateArbitrationDTO, options: any = {}): RequestArgs {
            // verify required parameter 'arbitrationId' is not null or undefined
            if (arbitrationId === null || arbitrationId === undefined) {
                throw new RequiredError('arbitrationId','Required parameter arbitrationId was null or undefined when calling updateArbitration.');
            }
            // verify required parameter 'updateArbitrationDTO' is not null or undefined
            if (updateArbitrationDTO === null || updateArbitrationDTO === undefined) {
                throw new RequiredError('updateArbitrationDTO','Required parameter updateArbitrationDTO was null or undefined when calling updateArbitration.');
            }
            const localVarPath = `/v2/arbitrations/{arbitrationId}`
                .replace(`{${"arbitrationId"}}`, encodeURIComponent(String(arbitrationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateArbitrationDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateArbitrationDTO !== undefined ? updateArbitrationDTO : {}) : (updateArbitrationDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArbitrationsApi - functional programming interface
 * @export
 */
export const ArbitrationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create an Arbitration on a Claim, optionally attaching the summary document and publishing it
         * @param {string} claimId 
         * @param {number} [arbitratedAmount] 
         * @param {any} [file] Arbitration summary document
         * @param {boolean} [publish] Publish the arbitration in the same request. Requires a summary document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArbitration(claimId: string, arbitratedAmount?: number, file?: any, publish?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArbitrationDTO> {
            const localVarAxiosArgs = ArbitrationsApiAxiosParamCreator(configuration).createArbitration(claimId, arbitratedAmount, file, publish, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an Arbitration by Id
         * @param {string} id Arbitration id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArbitrationById(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArbitrationDTO> {
            const localVarAxiosArgs = ArbitrationsApiAxiosParamCreator(configuration).getArbitrationById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Publish an Arbitration on a Claim
         * @param {string} arbitrationId Arbitration id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishArbitration(arbitrationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArbitrationDTO> {
            const localVarAxiosArgs = ArbitrationsApiAxiosParamCreator(configuration).publishArbitration(arbitrationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update an Arbitration on a Claim
         * @param {string} arbitrationId Arbitration id
         * @param {UpdateArbitrationDTO} updateArbitrationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArbitration(arbitrationId: string, updateArbitrationDTO: UpdateArbitrationDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArbitrationDTO> {
            const localVarAxiosArgs = ArbitrationsApiAxiosParamCreator(configuration).updateArbitration(arbitrationId, updateArbitrationDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ArbitrationsApi - factory interface
 * @export
 */
export const ArbitrationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create an Arbitration on a Claim, optionally attaching the summary document and publishing it
         * @param {string} claimId 
         * @param {number} [arbitratedAmount] 
         * @param {any} [file] Arbitration summary document
         * @param {boolean} [publish] Publish the arbitration in the same request. Requires a summary document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArbitration(claimId: string, arbitratedAmount?: number, file?: any, publish?: boolean, options?: any) {
            return ArbitrationsApiFp(configuration).createArbitration(claimId, arbitratedAmount, file, publish, options)(axios, basePath);
        },
        /**
         * Get an Arbitration by Id
         * @param {string} id Arbitration id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArbitrationById(id: string, options?: any) {
            return ArbitrationsApiFp(configuration).getArbitrationById(id, options)(axios, basePath);
        },
        /**
         * Publish an Arbitration on a Claim
         * @param {string} arbitrationId Arbitration id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishArbitration(arbitrationId: string, options?: any) {
            return ArbitrationsApiFp(configuration).publishArbitration(arbitrationId, options)(axios, basePath);
        },
        /**
         * Update an Arbitration on a Claim
         * @param {string} arbitrationId Arbitration id
         * @param {UpdateArbitrationDTO} updateArbitrationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArbitration(arbitrationId: string, updateArbitrationDTO: UpdateArbitrationDTO, options?: any) {
            return ArbitrationsApiFp(configuration).updateArbitration(arbitrationId, updateArbitrationDTO, options)(axios, basePath);
        },
    };
};

/**
 * ArbitrationsApi - interface
 * @export
 * @interface ArbitrationsApi
 */
export interface ArbitrationsApiInterface {
    /**
     * Create an Arbitration on a Claim, optionally attaching the summary document and publishing it
     * @param {string} claimId 
     * @param {number} [arbitratedAmount] 
     * @param {any} [file] Arbitration summary document
     * @param {boolean} [publish] Publish the arbitration in the same request. Requires a summary document.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArbitrationsApiInterface
     */
    createArbitration(claimId: string, arbitratedAmount?: number, file?: any, publish?: boolean, options?: any): AxiosPromise<ArbitrationDTO>;

    /**
     * Get an Arbitration by Id
     * @param {string} id Arbitration id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArbitrationsApiInterface
     */
    getArbitrationById(id: string, options?: any): AxiosPromise<ArbitrationDTO>;

    /**
     * Publish an Arbitration on a Claim
     * @param {string} arbitrationId Arbitration id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArbitrationsApiInterface
     */
    publishArbitration(arbitrationId: string, options?: any): AxiosPromise<ArbitrationDTO>;

    /**
     * Update an Arbitration on a Claim
     * @param {string} arbitrationId Arbitration id
     * @param {UpdateArbitrationDTO} updateArbitrationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArbitrationsApiInterface
     */
    updateArbitration(arbitrationId: string, updateArbitrationDTO: UpdateArbitrationDTO, options?: any): AxiosPromise<ArbitrationDTO>;

}

/**
 * ArbitrationsApi - object-oriented interface
 * @export
 * @class ArbitrationsApi
 * @extends {BaseAPI}
 */
export class ArbitrationsApi extends BaseAPI implements ArbitrationsApiInterface {
    /**
     * Create an Arbitration on a Claim, optionally attaching the summary document and publishing it
     * @param {string} claimId 
     * @param {number} [arbitratedAmount] 
     * @param {any} [file] Arbitration summary document
     * @param {boolean} [publish] Publish the arbitration in the same request. Requires a summary document.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArbitrationsApi
     */
    public createArbitration(claimId: string, arbitratedAmount?: number, file?: any, publish?: boolean, options?: any) {
        return ArbitrationsApiFp(this.configuration).createArbitration(claimId, arbitratedAmount, file, publish, options)(this.axios, this.basePath);
    }

    /**
     * Get an Arbitration by Id
     * @param {string} id Arbitration id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArbitrationsApi
     */
    public getArbitrationById(id: string, options?: any) {
        return ArbitrationsApiFp(this.configuration).getArbitrationById(id, options)(this.axios, this.basePath);
    }

    /**
     * Publish an Arbitration on a Claim
     * @param {string} arbitrationId Arbitration id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArbitrationsApi
     */
    public publishArbitration(arbitrationId: string, options?: any) {
        return ArbitrationsApiFp(this.configuration).publishArbitration(arbitrationId, options)(this.axios, this.basePath);
    }

    /**
     * Update an Arbitration on a Claim
     * @param {string} arbitrationId Arbitration id
     * @param {UpdateArbitrationDTO} updateArbitrationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArbitrationsApi
     */
    public updateArbitration(arbitrationId: string, updateArbitrationDTO: UpdateArbitrationDTO, options?: any) {
        return ArbitrationsApiFp(this.configuration).updateArbitration(arbitrationId, updateArbitrationDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ArbitrationsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Create an Arbitration on a Claim, optionally attaching the summary document and publishing it
 * @param {string} claimId 
 * @param {number} [arbitratedAmount] 
 * @param {any} [file] Arbitration summary document
 * @param {boolean} [publish] Publish the arbitration in the same request. Requires a summary document.
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createArbitration(
    claimId: string,
    arbitratedAmount?: number,
    file?: any,
    publish?: boolean,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ArbitrationDTO> {
    const localVarAxiosArgs = ArbitrationsApiAxiosParamCreator(configuration).createArbitration(claimId, arbitratedAmount, file, publish, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an Arbitration by Id
 * @param {string} id Arbitration id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getArbitrationById(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ArbitrationDTO> {
    const localVarAxiosArgs = ArbitrationsApiAxiosParamCreator(configuration).getArbitrationById(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Publish an Arbitration on a Claim
 * @param {string} arbitrationId Arbitration id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function publishArbitration(
    arbitrationId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ArbitrationDTO> {
    const localVarAxiosArgs = ArbitrationsApiAxiosParamCreator(configuration).publishArbitration(arbitrationId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update an Arbitration on a Claim
 * @param {string} arbitrationId Arbitration id
 * @param {UpdateArbitrationDTO} updateArbitrationDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateArbitration(
    arbitrationId: string,
    updateArbitrationDTO: UpdateArbitrationDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ArbitrationDTO> {
    const localVarAxiosArgs = ArbitrationsApiAxiosParamCreator(configuration).updateArbitration(arbitrationId, updateArbitrationDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

